import { NgClass } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faUpload } from '@fortawesome/free-solid-svg-icons';
import { FileUploadModule } from 'ng2-file-upload';
import { NgxSpinnerModule } from 'ngx-spinner';
import { FolderDocument } from 'src/app/models/server/folder-document';
import { SpinnerService } from 'src/app/services/core/spinner.service';
import { ConnectedUsersStateService } from 'src/app/services/state/connected-users-state.service';
import { environment } from 'src/environments/environment';
import { OnKeyEnterEventDirective } from '../../../core/directives/on-key-enter-event.directive';
import { FileUploaderCustom } from '../../../core/file-uploader-custom';
import { AvmFileSizePipe } from '../../../core/pipes/avm-file-size.pipe';
import { DialogAddFileData } from './models/dialog-add-file-data';

@Component({
    selector: 'app-add-file',
    templateUrl: './add-file.component.html',
    styleUrls: ['./add-file.component.scss'],
    imports: [
        FileUploadModule,
        NgClass,
        MatCardModule,
        MatButtonModule,
        MatTooltipModule,
        FaIconComponent,
        MatIconModule,
        MatFormFieldModule,
        MatInputModule,
        FormsModule,
        OnKeyEnterEventDirective,
        ReactiveFormsModule,
        NgxSpinnerModule,
        AvmFileSizePipe,
    ]
})
export class AddFileComponent implements OnInit {
    public uploadIcon = faUpload;

    /**
     * URL pour le webService d'upload.
     */
    get baseUrl() {
        if (environment.production) {
            return '';
        } else {
            return environment.serverUrl;
        }
    }

    /**
     * Champs du formulaire de saisie de commentaire.
     */
    public commentFormControl = new UntypedFormControl(null);

    /**
     * Composant d'upload de fichiers.
     */
    public uploader: FileUploaderCustom = null;

    public fileDropZoneOver: boolean = false;

    /**
     * Constructeur.
     * @param connectedUserStateService
     * @param dialogRef
     * @param data
     */
    constructor(
        private connectedUserStateService: ConnectedUsersStateService,
        public dialogRef: MatDialogRef<AddFileComponent>,
        private spinner: SpinnerService,
        @Inject(MAT_DIALOG_DATA) public data: DialogAddFileData
    ) {}

    /**
     * Appelée à l'initialisation du composant.
     */
    ngOnInit(): void {
        const user = this.connectedUserStateService.getUserConnected();
        this.uploader = new FileUploaderCustom({
            url: `${this.baseUrl}/api/organizations/${user.organization.id}/views/${this.data.folderViewId}/folders/${this.data.folderId}/document`,
            authTokenHeader: 'Authorization',
            authToken: `Bearer ${user.token.accessToken}`,
            disableMultipart: false,
            queueLimit: 50,
        });

        this.uploader.onAfterAddingFile = (fileItem) => {
            fileItem.withCredentials = false;
        };

        this.uploader.onSuccessItem = (fileItem, response) => {
            var document = FolderDocument.fromJson(JSON.parse(response));
            this.dialogRef.close(document);
            this.spinner.hide('add-file-spinner');
        };
    }

    /**
     * Appelée lorsque l'utilisateur clique sur le bouton 'Annuler'.
     */
    public cancel(): void {
        this.dialogRef.close(null);
    }

    /**
     * Appelée lorsque l'utilisateur clique sur le bouton 'Valider'.
     */
    public upload(): void {
        this.spinner.show('add-file-spinner');
        this.uploader.uploadAllFiles(this.commentFormControl.value);
    }

    /**
     * Appelée lorsque l'utilisateur clique sur la touche ENTREE depuis le champ commentaire.
     */
    public validate() {
        if (this.uploader.queue.length !== 0) {
            this.upload();
        }
    }

    public fileOver(e: any) {
        this.fileDropZoneOver = e;
    }
}
